import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import icon from 'flarum/common/helpers/icon';

import { HOME_SECTIONS } from '../config/homeSections.mjs';
import { formatUnreadCount } from '../utils/unreadCounts.mjs';

export default {
  view(vnode) {
    const translationPrefix = 'yingtao-forum-homepage.forum.sections';
    const unreadCounts = vnode.attrs.unreadCounts || {};

    return (
      <section className="YingtaoSections" aria-labelledby="yingtao-sections-title">
        <header className="YingtaoSectionHeader">
          <h2 id="yingtao-sections-title">{app.translator.trans(`${translationPrefix}.title`)}</h2>
          <div className="YingtaoSectionHeader-prompt">
            <span>{app.translator.trans(`${translationPrefix}.prompt`)}</span>
            <Button
              icon="fas fa-edit"
              className="Button Button--link YingtaoSectionPrompt-action"
              onclick={vnode.attrs.onStartDiscussion}
            >
              {app.translator.trans(`${translationPrefix}.direct_publish`)}
            </Button>
          </div>
        </header>
        <div className="YingtaoSectionGrid">
          {HOME_SECTIONS.map((section) => {
            const unreadCount = Number(unreadCounts[section.slug]) || 0;
            const href = section.kind === 'route'
              ? (app.forum.attribute('basePath') || '') + section.href
              : app.route('tag', { tags: section.slug });

            return (
              <Link
                key={section.slug}
                href={href}
                className={`YingtaoSectionCard YingtaoSectionCard--${section.tone}`}
              >
                {icon(section.icon, { className: 'YingtaoSectionCard-icon' })}
                <div className="YingtaoSectionCard-copy">
                  <h3>
                    <span className="YingtaoSectionCard-title">
                      {app.translator.trans(`${translationPrefix}.${section.titleKey}`)}
                    </span>
                    {unreadCount > 0 ? (
                      <span
                        className="YingtaoUnreadBadge"
                        aria-label={app.translator.trans('yingtao-forum-homepage.forum.unread_label', {
                          count: unreadCount,
                        })}
                      >
                        {formatUnreadCount(unreadCount)}
                      </span>
                    ) : null}
                  </h3>
                  <p>{app.translator.trans(`${translationPrefix}.${section.descriptionKey}`)}</p>
                </div>
                {icon('fas fa-arrow-right', { className: 'YingtaoSectionCard-arrow' })}
              </Link>
            );
          })}
        </div>
      </section>
    );
  },
};
